webpackJsonp([66],{

/***/ "JO6v":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-company-info_27aa3428de66376bbda3eb25e1896180.html";

/***/ }),

/***/ "s9xa":
/***/ (function(module, exports, __webpack_require__) {

var SectionCompanyInfo = (function () {
    function SectionCompanyInfo() {
    }
    return SectionCompanyInfo;
}());
angular.module('animatronApp.sectionCompanyInfo', []).component('sectionCompanyInfo', {
    bindings: {
        ltTitle: '<',
        title2: '<',
        logoUrl: '<',
        description: '<',
        background: '<',
        list: '<',
    },
    controller: SectionCompanyInfo,
    templateUrl: __webpack_require__("JO6v")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/66-28dc41a6a889e793a2e2.min.js